// extracted by mini-css-extract-plugin
module.exports = {"background_root":"Background_background_root__1RxoO","background_child-container":"Background_background_child-container__v14JA"};